var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.closedByUserRecently
    ? _c(
        "div",
        {
          staticClass: "welcome-message-wrapper",
          on: {
            mouseenter: _vm.onMouseEnter,
            mouseleave: _vm.onMouseLeave,
            click: function ($event) {
              return _vm.$emit("click")
            },
          },
        },
        [
          _c("div", { staticClass: "welcome-message-close-wrapper" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowingCloseWelcomeMessage,
                    expression: "isShowingCloseWelcomeMessage",
                  },
                ],
                staticClass: "button welcome-message-close",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.onCloseClicked.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "ma",
                    attrs: { viewBox: "0 0 20 20", width: "8", fill: "white" },
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xlink:href": "#icon-close",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "welcome-message",
            domProps: { innerHTML: _vm._s(_vm.sanitizedDescription) },
          }),
          _vm._v(" "),
          _vm._m(0),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "triangle-wrapper" }, [
      _c("div", { staticClass: "triangle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }